function maximizeKendoWindowOnMobile(kendoWindow) {
    // For small screens, maximize the window when it is shown.
    var $window = $(window);
    if ($window.width() < 875 || $window.height() < 600) {
        kendoWindow.maximize();
    }
}